module.exports = __webpack_public_path__ + "static/media/5.00fb90c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/GalleryPage/images/biquad/5.png
// module id = 1526
// module chunks = 0